// 확정세번 집계 표시 변환(순수) — Master-Detail 좌 패널용.

/** summary 응답 items → {hsk, cnt(number), label "세번 (1,234)"} 목록(순서 보존). */
export function summaryView(items) {
  return (items || []).map((r) => {
    const cnt = Number(r.cnt) || 0;
    return {
      hsk: String(r.hsk),
      cnt,
      label: `${r.hsk} (${cnt.toLocaleString("ko-KR")})`,
    };
  });
}

export function totalCount(items) {
  return (items || []).reduce((s, r) => s + (Number(r.cnt) || 0), 0);
}
